// // /* ============================================================
// //    LB-PRODUCT.JS — Page produit
// //    ============================================================ */
// // 'use strict';

// // const ProductPage = {
// //   form:     null,
// //   variants: null,
// //   current:  null,

// //   init() {
// //     this.form = document.querySelector('[data-prod-form]');
// //     if (!this.form) return;
// //     const vJSON = document.querySelector('[data-variants-json]');
// //     if (vJSON) { try { this.variants = JSON.parse(vJSON.textContent); } catch(e){} }
// //     this._bindOptions();
// //     this._bindQty();
// //     this._initFromURL();
// //   },

// //   _bindOptions() {
// //     this.form.querySelectorAll('[data-opt-btn]').forEach(btn => {
// //       btn.addEventListener('click', () => {
// //         const idx = btn.dataset.optIdx;
// //         this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${idx}"]`).forEach(b => b.classList.remove('selected'));
// //         btn.classList.add('selected');
// //         const lbl = this.form.querySelector(`[data-opt-selected="${idx}"]`);
// //         if (lbl) lbl.textContent = btn.dataset.value;
// //         this._updateVariant();
// //       });
// //     });
// //   },

// //   _bindQty() {
// //     const wrap    = this.form.querySelector('.qty-ctrl');
// //     if (!wrap) return;
// //     const input   = wrap.querySelector('[data-qty-input]');
// //     const plusBtn = wrap.querySelector('[data-qty-plus]');
// //     const minBtn  = wrap.querySelector('[data-qty-minus]');
// //     const clamp   = v => Math.max(1, Math.min(v, parseInt(input.max || '99')));
// //     const set     = v => {
// //       input.value = clamp(v);
// //       if (minBtn)  minBtn.disabled  = parseInt(input.value) <= 1;
// //       if (plusBtn) plusBtn.disabled = parseInt(input.value) >= parseInt(input.max || '99');
// //     };
// //     plusBtn?.addEventListener('click', () => set(parseInt(input.value) + 1));
// //     minBtn?.addEventListener('click',  () => set(parseInt(input.value) - 1));
// //     input?.addEventListener('change',  () => set(parseInt(input.value) || 1));
// //   },

// //   _getSelected() {
// //     const opts = [];
// //     this.form.querySelectorAll('[data-opt-group]').forEach(g => {
// //       opts.push(g.querySelector('[data-opt-btn].selected')?.dataset.value || null);
// //     });
// //     return opts;
// //   },

// //   _updateVariant() {
// //     if (!this.variants) return;
// //     const sel     = this._getSelected();
// //     const variant = this.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
// //     this.current  = variant;
// //     const fm      = window.LB?.formatMoney || (c => (c/100).toFixed(2) + '€');
// //     // Price
// //     const priceEl = this.form.querySelector('[data-pf-price]');
// //     const wasEl   = this.form.querySelector('[data-pf-was]');
// //     const saveEl  = this.form.querySelector('[data-pf-save]');
// //     if (priceEl && variant) priceEl.textContent = fm(variant.price);
// //     if (wasEl) {
// //       if (variant?.compare_at_price > variant?.price) {
// //         wasEl.textContent = fm(variant.compare_at_price);
// //         wasEl.style.display = '';
// //         if (saveEl) { saveEl.textContent = `-${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}%`; saveEl.style.display = ''; }
// //       } else {
// //         wasEl.style.display = 'none';
// //         if (saveEl) saveEl.style.display = 'none';
// //       }
// //     }
// //     // Stock
// //     const stockEl = this.form.querySelector('[data-stock]');
// //     if (stockEl && variant) stockEl.innerHTML = this._stockHTML(variant);
// //     // ATC button
// //     const atcBtn  = this.form.querySelector('[data-atc-btn]');
// //     const atcText = atcBtn?.querySelector('.btn-text');
// //     if (atcBtn) {
// //       atcBtn.disabled = !variant?.available;
// //       if (atcText) atcText.textContent = variant?.available ? 'Ajouter au panier' : 'Rupture de stock';
// //     }
// //     // Buy now link
// //     const buyNow = this.form.querySelector('[data-buy-now]');
// //     if (buyNow && variant) buyNow.href = `/checkout?variant=${variant.id}&quantity=1`;
// //     // Hidden input
// //     const hiddenId = this.form.querySelector('[name="id"]');
// //     if (hiddenId && variant) hiddenId.value = variant.id;
// //     // Qty max
// //     const qInput = this.form.querySelector('[data-qty-input]');
// //     if (qInput && variant) qInput.max = variant.inventory_quantity > 0 ? variant.inventory_quantity : 99;
// //     // URL
// //     if (variant) {
// //       const u = new URL(location.href);
// //       u.searchParams.set('variant', variant.id);
// //       history.replaceState({}, '', u);
// //     }
// //   },

// //   _stockHTML(v) {
// //     if (!v.available) return `<span class="stock-dot stock-dot--out"></span><span class="stock-out">Rupture de stock</span>`;
// //     if (v.inventory_quantity > 0 && v.inventory_quantity <= 5)
// //       return `<span class="stock-dot stock-dot--low"></span><span class="stock-low">Plus que ${v.inventory_quantity} en stock</span>`;
// //     return `<span class="stock-dot stock-dot--in"></span><span class="stock-in">En stock</span>`;
// //   },

// //   _initFromURL() {
// //     const vId = new URLSearchParams(location.search).get('variant');
// //     if (vId && this.variants) {
// //       const v = this.variants.find(x => x.id == vId);
// //       if (v) {
// //         v.options.forEach((val, i) => {
// //           const btn = this.form.querySelector(`[data-opt-btn][data-opt-idx="${i}"][data-value="${val}"]`);
// //           if (btn) {
// //             this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${i}"]`).forEach(b => b.classList.remove('selected'));
// //             btn.classList.add('selected');
// //             const lbl = this.form.querySelector(`[data-opt-selected="${i}"]`);
// //             if (lbl) lbl.textContent = val;
// //           }
// //         });
// //       }
// //     }
// //     this._updateVariant();
// //   }
// // };

// // document.addEventListener('DOMContentLoaded', () => ProductPage.init());
// /* ============================================================
//    LB-PRODUCT.JS — Page produit
//    FIX : alignement classes V2 (v2-opt-btn--sel / v2-opt-btn)
//    ============================================================ */
// 'use strict';

// const ProductPage = {
//   form:     null,
//   variants: null,
//   current:  null,

//   init() {
//     this.form = document.querySelector('[data-prod-form]');
//     if (!this.form) return;

//     // Si la section a déjà son propre script inline (V2), on ne relie pas les options
//     // pour éviter le double-binding — on se contente de lire l'état courant.
//     const vJSON = document.querySelector('[data-variants-json]');
//     if (vJSON) { try { this.variants = JSON.parse(vJSON.textContent); } catch(e){} }

//     this._bindOptions();
//     this._bindQty();
//     this._initFromURL();
//   },

//   _bindOptions() {
//     // Supporte les deux conventions de classe :
//     //   V2  → .v2-opt-btn  /  .v2-opt-btn--sel
//     //   V1  → [data-opt-btn]  /  .selected
//     this.form.querySelectorAll('[data-opt-btn]').forEach(btn => {
//       btn.addEventListener('click', () => {
//         const idx = btn.dataset.optIdx;
//         // Retire la sélection sur tous les boutons du même groupe
//         this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${idx}"]`).forEach(b => {
//           b.classList.remove('selected', 'v2-opt-btn--sel');
//         });
//         // Ajoute les deux classes pour compatibilité V1 + V2
//         btn.classList.add('selected', 'v2-opt-btn--sel');

//         const lbl = this.form.querySelector(`[data-opt-selected="${idx}"]`);
//         if (lbl) lbl.textContent = btn.dataset.value;
//         this._updateVariant();
//       });
//     });
//   },

//   _bindQty() {
//     const wrap    = this.form.querySelector('.qty-ctrl');
//     if (!wrap) return;
//     const input   = wrap.querySelector('[data-qty-input]');
//     const plusBtn = wrap.querySelector('[data-qty-plus]');
//     const minBtn  = wrap.querySelector('[data-qty-minus]');
//     const clamp   = v => Math.max(1, Math.min(v, parseInt(input.max || '99')));
//     const set     = v => {
//       input.value = clamp(v);
//       if (minBtn)  minBtn.disabled  = parseInt(input.value) <= 1;
//       if (plusBtn) plusBtn.disabled = parseInt(input.value) >= parseInt(input.max || '99');
//     };
//     plusBtn?.addEventListener('click', () => set(parseInt(input.value) + 1));
//     minBtn?.addEventListener('click',  () => set(parseInt(input.value) - 1));
//     input?.addEventListener('change',  () => set(parseInt(input.value) || 1));
//   },

//   _getSelected() {
//     const opts = [];
//     this.form.querySelectorAll('[data-opt-group]').forEach(g => {
//       // Cherche d'abord la classe V2, puis la classe V1
//       const active = g.querySelector('[data-opt-btn].v2-opt-btn--sel')
//                   || g.querySelector('[data-opt-btn].selected');
//       opts.push(active?.dataset.value || null);
//     });
//     return opts;
//   },

//   _updateVariant() {
//     if (!this.variants) return;
//     const sel     = this._getSelected();
//     const variant = this.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
//     this.current  = variant;
//     const fm      = window.LB?.formatMoney || (c => (c/100).toLocaleString('fr-FR', {style:'currency',currency:'EUR'}));

//     // Price
//     const priceEl = this.form.querySelector('[data-pf-price]');
//     const wasEl   = this.form.querySelector('[data-pf-was]');
//     const saveEl  = this.form.querySelector('[data-pf-save]');
//     if (priceEl && variant) priceEl.textContent = fm(variant.price);
//     if (wasEl) {
//       if (variant?.compare_at_price > variant?.price) {
//         wasEl.textContent = fm(variant.compare_at_price);
//         wasEl.style.display = '';
//         if (saveEl) {
//           saveEl.textContent = `-${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}%`;
//           saveEl.style.display = '';
//         }
//       } else {
//         wasEl.style.display = 'none';
//         if (saveEl) saveEl.style.display = 'none';
//       }
//     }

//     // Stock
//     const stockEl = this.form.querySelector('[data-stock]');
//     if (stockEl && variant) stockEl.innerHTML = this._stockHTML(variant);

//     // ATC button
//     const atcBtn  = this.form.querySelector('[data-atc-btn]');
//     const atcText = atcBtn?.querySelector('.btn-text, .v2-atc__text');
//     if (atcBtn) {
//       atcBtn.disabled = !variant?.available;
//       if (atcText && variant) {
//         atcText.innerHTML = variant.available
//           ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Ajouter au panier`
//           : 'Rupture de stock';
//       }
//     }

//     // Buy now link
//     const buyNow = this.form.querySelector('[data-buy-now]');
//     if (buyNow && variant) buyNow.href = `/checkout?variant=${variant.id}&quantity=1`;

//     // Hidden input
//     const hiddenId = this.form.querySelector('[name="id"]');
//     if (hiddenId && variant) hiddenId.value = variant.id;

//     // Qty max
//     const qInput = this.form.querySelector('[data-qty-input]');
//     if (qInput && variant) qInput.max = variant.inventory_quantity > 0 ? variant.inventory_quantity : 99;

//     // URL
//     if (variant) {
//       const u = new URL(location.href);
//       u.searchParams.set('variant', variant.id);
//       history.replaceState({}, '', u);
//     }
//   },

//   _stockHTML(v) {
//     if (!v.available) return `<span class="v2-stock__dot v2-stock__dot--out"></span><span class="v2-stock__label v2-stock__label--out">Rupture de stock</span>`;
//     if (v.inventory_quantity > 0 && v.inventory_quantity <= 5)
//       return `<span class="v2-stock__dot v2-stock__dot--low"></span><span class="v2-stock__label v2-stock__label--low">Plus que ${v.inventory_quantity} en stock</span>`;
//     return `<span class="v2-stock__dot v2-stock__dot--in"></span><span class="v2-stock__label v2-stock__label--in">En stock · Expédition sous 24h</span>`;
//   },

//   _initFromURL() {
//     const vId = new URLSearchParams(location.search).get('variant');
//     if (vId && this.variants) {
//       const v = this.variants.find(x => x.id == vId);
//       if (v) {
//         v.options.forEach((val, i) => {
//           const btn = this.form.querySelector(`[data-opt-btn][data-opt-idx="${i}"][data-value="${val}"]`);
//           if (btn) {
//             this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${i}"]`).forEach(b => {
//               b.classList.remove('selected', 'v2-opt-btn--sel');
//             });
//             btn.classList.add('selected', 'v2-opt-btn--sel');
//             const lbl = this.form.querySelector(`[data-opt-selected="${i}"]`);
//             if (lbl) lbl.textContent = val;
//           }
//         });
//       }
//     }
//     this._updateVariant();
//   }
// };

// document.addEventListener('DOMContentLoaded', () => ProductPage.init());



/* ============================================================
   LB-PRODUCT.JS — Page produit
   FIX FINAL :
   - Produit sans options (variante unique) → bouton activé dès le chargement
   - _getSelected() null → prend variants[0] directement
   - Gère le submit ATC ici (évite conflit avec lb-cart.js _bindForms)
   - Classes V2 (v2-opt-btn--sel) + V1 (.selected) supportées
   ============================================================ */
'use strict';

const ProductPage = {
  form:     null,
  variants: null,
  current:  null,

  init() {
    this.form = document.querySelector('[data-prod-form]');
    if (!this.form) return;

    const vJSON = document.querySelector('[data-variants-json]');
    if (vJSON) {
      try { this.variants = JSON.parse(vJSON.textContent); } catch(e) {}
    }

    this._bindOptions();
    this._bindQty();
    this._bindSubmit();
    this._initFromURL(); // appelle _updateVariant en fin
  },

  /* ── Options ── */
  _bindOptions() {
    this.form.querySelectorAll('[data-opt-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = btn.dataset.optIdx;
        this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${idx}"]`).forEach(b => {
          b.classList.remove('selected', 'v2-opt-btn--sel');
        });
        btn.classList.add('selected', 'v2-opt-btn--sel');
        const lbl = this.form.querySelector(`[data-opt-selected="${idx}"]`);
        if (lbl) lbl.textContent = btn.dataset.value;
        this._updateVariant();
      });
    });
  },

  /* ── Qty boutons V2 (data-qty-minus / data-qty-plus) ── */
  _bindQty() {
    const qtyInput = this.form.querySelector('[data-qty-input]');
    if (!qtyInput) return;

    this.form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    this.form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const v   = parseInt(qtyInput.value) || 1;
      const max = parseInt(qtyInput.max) || 99;
      if (v < max) qtyInput.value = v + 1;
    });

    // Fallback pour wrapper .qty-ctrl (V1)
    const wrap = this.form.querySelector('.qty-ctrl');
    if (wrap) {
      const input   = wrap.querySelector('[data-qty-input]');
      const plusBtn = wrap.querySelector('[data-qty-plus]');
      const minBtn  = wrap.querySelector('[data-qty-minus]');
      if (!input) return;
      const clamp = v => Math.max(1, Math.min(v, parseInt(input.max || '99')));
      const set   = v => { input.value = clamp(v); };
      plusBtn?.addEventListener('click', () => set(parseInt(input.value) + 1));
      minBtn?.addEventListener('click',  () => set(parseInt(input.value) - 1));
      input?.addEventListener('change',  () => set(parseInt(input.value) || 1));
    }
  },

  /* ── Submit ATC via Cart.addItem (lb-cart.js) ── */
  _bindSubmit() {
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation(); // empêche lb-cart.js de binder en double

      const btn = this.form.querySelector('[data-atc-btn]');
      if (btn?.disabled) return;

      const variantId = parseInt(this.form.querySelector('[name="id"]')?.value);
      const qty       = parseInt(this.form.querySelector('[data-qty-input]')?.value || '1');
      if (!variantId) return;

      // Utilise Cart.addItem si disponible (lb-cart.js)
      if (window.LB?.Cart?.addItem) {
        await window.LB.Cart.addItem(variantId, qty, btn);
        return;
      }

      // Fallback natif si lb-cart.js non chargé
      if (btn) { btn.disabled = true; }
      try {
        const fd  = new FormData(this.form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok) throw new Error();

        const atcText = btn?.querySelector('.v2-atc__text, .btn-text');
        if (atcText) {
          const orig = atcText.innerHTML;
          atcText.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Ajouté !`;
          if (btn) { btn.style.background = '#2D6A4F'; btn.style.borderColor = '#2D6A4F'; }
          setTimeout(() => {
            atcText.innerHTML = orig;
            if (btn) { btn.style.background = ''; btn.style.borderColor = ''; btn.disabled = false; }
          }, 2000);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch {
        const atcText = btn?.querySelector('.v2-atc__text, .btn-text');
        if (atcText) atcText.textContent = 'Erreur — réessayer';
        if (btn) { btn.style.background = '#B93535'; }
        setTimeout(() => {
          if (atcText) atcText.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Ajouter au panier`;
          if (btn) { btn.style.background = ''; btn.disabled = false; }
        }, 2500);
      }
    }, { capture: true }); // capture:true pour passer avant le listener de lb-cart.js
  },

  /* ── Lecture des options sélectionnées ── */
  _getSelected() {
    const groups = this.form.querySelectorAll('[data-opt-group]');
    if (!groups.length) return null; // variante unique → null

    const opts = [];
    groups.forEach(g => {
      const active = g.querySelector('[data-opt-btn].v2-opt-btn--sel')
                  || g.querySelector('[data-opt-btn].selected');
      opts.push(active?.dataset.value ?? null);
    });
    return opts;
  },

  /* ── Résolution variante + mise à jour UI ── */
  _updateVariant() {
    if (!this.variants || !this.variants.length) return;

    const sel = this._getSelected();

    let variant;
    if (sel === null) {
      // Variante unique (pas d'options) → toujours la première
      variant = this.variants[0];
    } else {
      variant = this.variants.find(v =>
        v.options.every((o, i) => o === sel[i])
      ) || null;
    }

    if (!variant) return; // sécurité — ne pas toucher au bouton si pas trouvée
    this.current = variant;

    const fm = window.LB?.formatMoney
      || (c => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }));

    /* Prix */
    const priceEl = this.form.querySelector('[data-pf-price]');
    const wasEl   = this.form.querySelector('[data-pf-was]');
    const saveEl  = this.form.querySelector('[data-pf-save]');
    if (priceEl) priceEl.textContent = fm(variant.price);
    if (wasEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        wasEl.textContent   = fm(variant.compare_at_price);
        wasEl.style.display = '';
        if (saveEl) {
          saveEl.textContent   = `-${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}%`;
          saveEl.style.display = '';
        }
      } else {
        wasEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    /* Stock */
    const stockEl = this.form.querySelector('[data-stock]');
    if (stockEl) stockEl.innerHTML = this._stockHTML(variant);

    /* Bouton ATC ← FIX PRINCIPAL */
    const atcBtn  = this.form.querySelector('[data-atc-btn]');
    const atcText = atcBtn?.querySelector('.v2-atc__text, .btn-text');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      if (atcText) {
        atcText.innerHTML = variant.available
          ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
               <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
               <line x1="3" y1="6" x2="21" y2="6"/>
               <path d="M16 10a4 4 0 01-8 0"/>
             </svg> Ajouter au panier`
          : 'Rupture de stock';
      }
    }

    /* Acheter maintenant */
    const buyNow = this.form.querySelector('[data-buy-now]');
    if (buyNow) buyNow.href = `/checkout?variant=${variant.id}&quantity=1`;

    /* Input id caché */
    const hiddenId = this.form.querySelector('[name="id"]');
    if (hiddenId) hiddenId.value = variant.id;

    /* Qty max */
    const qInput = this.form.querySelector('[data-qty-input]');
    if (qInput) qInput.max = variant.inventory_quantity > 0 ? variant.inventory_quantity : 99;

    /* URL */
    try {
      const u = new URL(location.href);
      u.searchParams.set('variant', variant.id);
      history.replaceState({}, '', u);
    } catch(e) {}
  },

  _stockHTML(v) {
    if (!v.available)
      return `<span class="v2-stock__dot v2-stock__dot--out"></span><span class="v2-stock__label v2-stock__label--out">Rupture de stock</span>`;
    if (v.inventory_quantity > 0 && v.inventory_quantity <= 5)
      return `<span class="v2-stock__dot v2-stock__dot--low"></span><span class="v2-stock__label v2-stock__label--low">Plus que ${v.inventory_quantity} en stock</span>`;
    return `<span class="v2-stock__dot v2-stock__dot--in"></span><span class="v2-stock__label v2-stock__label--in">En stock · Expédition sous 24h</span>`;
  },

  /* ── Init depuis ?variant=xxx ── */
  _initFromURL() {
    const vId = new URLSearchParams(location.search).get('variant');
    if (vId && this.variants) {
      const v = this.variants.find(x => String(x.id) === String(vId));
      if (v) {
        v.options.forEach((val, i) => {
          const btn = this.form.querySelector(
            `[data-opt-btn][data-opt-idx="${i}"][data-value="${val}"]`
          );
          if (btn) {
            this.form.querySelectorAll(`[data-opt-btn][data-opt-idx="${i}"]`).forEach(b => {
              b.classList.remove('selected', 'v2-opt-btn--sel');
            });
            btn.classList.add('selected', 'v2-opt-btn--sel');
            const lbl = this.form.querySelector(`[data-opt-selected="${i}"]`);
            if (lbl) lbl.textContent = val;
          }
        });
      }
    }
    this._updateVariant();
  }
};

document.addEventListener('DOMContentLoaded', () => ProductPage.init());